module.exports = __webpack_public_path__ + "assets/img/logo-login.5f3da718.png";